export function canEditExistingDeductions(store) {
  const isAdmin = store.getters["authentication/isAdmin"];
  if (isAdmin && isAdmin != "false") return true;

  const raw = store.state.authentication.roles;
  const roles = Array.isArray(raw)
    ? raw
    : raw
    ? String(raw).split(",")
    : [];

  return (
    roles.indexOf("AbsentDeductionAdmin") !== -1 ||
    roles.indexOf("Admin") !== -1
  );
}
